import Phaser from "phaser";

let prefixByEnemyTypes = {
    BasicRat: 'basic-rat',
    WhiteRat: 'white-rat',
    CartoonWasp: 'cartoon-wasp',
    Mosquito: 'mosquito',
    Wasp: 'wasp',
    Lava: 'lava',
    MovingPlatform: 'moving-platform'
}

let scoreByEnemyTypes = {
    BasicRat: 100,
    WhiteRat: 200
}

let canBeKilledArray = ['WhiteRat', 'BasicRat']
let cannotKill = ['MovingPlatform']
let canBeKilledSet = new Set(canBeKilledArray)
let cannotKillSet = new Set(cannotKill)

let invertFlipX = {
    Lava: true
}
let dontFlipX = {
    MovingPlatform: true
}
let dontPlayAnims = {
    MovingPlatform: true
}
let collideOnlyUp = {
    MovingPlatform: true
}

const enemyOffsetByType = {
    BasicRat: {x: 40, y: 10},
    WhiteRat: {x: 40, y: 10},
    Lava: {x: 35, y: 24},
    Wasp: {x: 15, y: 55},
    CartoonWasp: {x: 15, y: 55},
    Mosquito: {x: 85, y: 55},
    MovingPlatform: {x: 0, y: 0},
}
const enemyOffsetFlipXByType = {
    BasicRat: {x: 70, y: 10},
    WhiteRat: {x: 70, y: 10},
    Lava: {x: 30, y: 24},
    Wasp: {x: 35, y: 55},
    CartoonWasp: {x: 35, y: 55},
    Mosquito: {x: 35, y: 55},
    MovingPlatform: {x: 0, y: 0},
}
const enemySizeByType = {
    BasicRat: {x: 80, y: 48},
    WhiteRat: {x: 80, y: 48},
    Lava: {x: 80, y: 80},
    Wasp: {x: 100, y: 50},
    CartoonWasp: {x: 110, y: 80},
    Mosquito: {x: 110, y: 110},
    MovingPlatform: {x: 128, y: 32},
}
// const enemySpeedByType = {
//     BasicRat: -300,
//     WhiteRat: -600,
//     Lava: -600,
//     Wasp: -400,
//     CartoonWasp: -600,
//     MovingPlatform: -300,
// }
const enemyVelocityByType = {
    BasicRat: {x: -300, y: 0},
    WhiteRat: {x: -600, y: 0},
    Lava: {x: -600, y: 0},
    Wasp: {x: -400, y: 0},
    CartoonWasp: {x: 0, y: -600},
    Mosquito: {x: -600, y: 0},
    MovingPlatform: {x: -300, y: 0},
}


export default class Enemy extends Phaser.Physics.Arcade.Sprite {
    constructor(scene, x, y, enemyType) {
        super(scene, x, y+12, `${prefixByEnemyTypes[enemyType]}-walk-sheet`, 0)
        this.enemyType = enemyType
        scene.add.existing(this)
        scene.physics.add.existing(this)
        this.velocity = enemyVelocityByType[enemyType]
        this.body.allowGravity = false
        this.setVelocity(this.velocity.x, this.velocity.y)
        this.setImmovable(true)
        this.setOrigin(0, 1)
        this.setSize(enemySizeByType[enemyType].x, enemySizeByType[this.enemyType].y)
        this.setOffset(enemyOffsetByType[enemyType].x, enemyOffsetByType[enemyType].y)


        
        if (invertFlipX[enemyType]) {
            this.setFlipX(true)
        }
        if (!dontPlayAnims[enemyType]) {
            this.anims.play(`${prefixByEnemyTypes[enemyType]}-walk`, true)
        }
        if (collideOnlyUp[enemyType]) {
            // this.body.checkCollision.up = true
            // this.body.checkCollision.left = false
            // this.body.checkCollision.right = false
            this.body.checkCollision.down = false
        }
    }

    handleCollisionWithWall = () => {
        this.velocity = {x: this.velocity.x*-1, y: this.velocity.y*-1}
        this.setVelocity(this.velocity.x, this.velocity.y)

        if (!dontFlipX[this.enemyType]) {
            let _setFlipX = Math.sign(this.velocity.x) === 1
            this.setFlipX(invertFlipX[this.enemyType] ? !_setFlipX : _setFlipX )
        }
        
        
        if (this.flipX) {
            this.setOffset(enemyOffsetFlipXByType[this.enemyType].x, enemyOffsetFlipXByType[this.enemyType].y)
        } else {
            this.setOffset(enemyOffsetByType[this.enemyType].x, enemyOffsetByType[this.enemyType].y)
        }
    }

    canBeKilled = () => {
        return canBeKilledSet.has(this.enemyType)
    }
    canKill = () => {
        return !cannotKillSet.has(this.enemyType)
    }

    kill = () => {
        if (this.killing || !canBeKilledSet.has(this.enemyType)) return false;
        this.killing = true
        this.body.checkCollision.none = true
        // this.setActive(false)
        this.anims.play(`${prefixByEnemyTypes[this.enemyType]}-dying`, true)
        this.setVelocity(0, 0)
        this.body.y += 10


        this.scene.updateEnemy(this.enemyType)


        this.scene.incrementScore(scoreByEnemyTypes[this.enemyType] || 0)
        this.scene.killEnemySound.play()

        this.on('animationcomplete', (animation) => {
            // console.log(animation)
            if (animation.key === `${prefixByEnemyTypes[this.enemyType]}-dying`) {
                this.setActive(false)
                setTimeout(() => {
                    try {
                        if (this && typeof this.destroy === 'function') {
                            this.destroy()
                        }
                    } catch (e) {
                        console.warn(e)
                    }
                    
                    // this && this.destroy && this.destroy();
                }, 3000)
            }
        })

        return true;
    }


}